/**
 * Contexto compartilhado do módulo Calendário: qual calendário/ensino/ano está selecionado.
 * Persistido em sessionStorage para sobreviver a F5 e a deep-links entre as telas do módulo
 * (Visão, Feriados, Paralisações, Atividades no calendário) sem re-selecionar a cada tela.
 */
export type Escopo = 'rede' | 'escola';

export type State = {
  ano: number;
  calendarioId: number;
  ensinoId: number;
  descricaoCalendario: string;
  escopo: Escopo;
};

const num = (chave: string): number => Number(sessionStorage.getItem(chave)) || 0;

export const state: State = {
  ano: num('cal_ctx_ano'),
  calendarioId: num('cal_ctx_calendarioId'),
  ensinoId: num('cal_ctx_ensinoId'),
  descricaoCalendario: sessionStorage.getItem('cal_ctx_descricao') ?? '',
  escopo: (sessionStorage.getItem('cal_ctx_escopo') as Escopo) || 'escola',
};
